module.exports = __webpack_public_path__ + "static/img/Plaid_(company)-Logo.wine.44283076.png";